const lockBodyScroll = (condition) => {
  document.querySelector('body').style.overflow = condition ? 'hidden' : '';
};

export default lockBodyScroll;
